module.exports = __webpack_public_path__ + "img/customizer-03.43160ec6.png";